import React from 'react';
import { getAgent } from '../../utils/agents';
import type { AgentId } from '../../types/anna';
export function AgentMark({
  agentId,
  size = 'md'
}: {
  agentId: AgentId;
  size?: 'sm' | 'md';
}) {
  const agent = getAgent(agentId);
  const Icon = agent.icon;
  return <span className={`grid shrink-0 place-items-center rounded-full ${size === 'sm' ? 'h-6 w-6' : 'h-8 w-8'}`} style={{
    backgroundColor: `${agent.color}1f`,
    color: agent.color,
    boxShadow: `inset 0 0 0 1px ${agent.color}40`
  }} aria-hidden data-id="element-1303" data-mp="hrszeg82rvcm">
      <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} strokeWidth={1.75} data-id="element-1304" data-mp="vjfx8kho1bxi" />
    </span>;
}